/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import IconImage from '../../components/IconImage';
import { updateBlockStyle } from './inline-styles';

const Edit = ( props ) => {
	const { isSelected, attributes, className } = props;
	const { source, iconName, iconImage, contentJustification } = attributes;

	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );

	// useEffect( () => {
	// 	setAttributes( { contentJustification: context[ 'my-plugin/recordId' ] } );
	// }, [ context ] );
	return (
		<div className={ classnames( className, {
			[ `is-content-justification-${ contentJustification }` ]: contentJustification,
		}, 'is-vertical' ) }>
			{ isSelected && <Inspector { ...props } /> }
			<div className="gutenify-icon-wrapper">
				{ 'icon' === source && <>
					<i className={ iconName }></i>
				</> }
				{ 'image' === source && ( iconImage && iconImage.url !== 'null' && iconImage.url !== '' ) &&

					<IconImage attributes={ attributes } />

				}
			</div>
		</div>
	);
};
export default Edit;
